export default function BasicInfoQuoterTheme() {
    return {
        typography: {
            fontFamily: "museo-sans",
            body1: {
                fontSize: 14,
                fontWeight: 500,
            },
        },
        components: {
            MuiFormControl: {
                styleOverrides: {
                    root: {
                        "&.coverage-amount": {
                            display: "flex",
                            alignItems: "center",
                        },
                        "&.coverage-amount .coverage-input": {
                            display: "flex",
                            width: 188,
                            height: 47,
                            alignItems: "center",
                            borderRadius: 6,

                        },
                        "&.coverage-amount .coverage-input::before": {
                            content: "none",
                        },
                        "&.coverage-amount .coverage-input::after": {
                            content: "none",
                        },
                        "&.coverage-amount .coverage-input input": {
                            padding: 0,
                        },
                    },
                },
            },
            MuiInputBase: {
                styleOverrides: {
                    input: {
                        fontSize: 16,
                    },
                    root: {
                        height: 56,
                    },
                },
            },
            MuiFilledInput: {
                styleOverrides: {
                    root: {
                        backgroundColor: "#f2f2f2",
                    },
                    underline: {
                        "&::before": {
                            borderBottom: "solid 2px #b2b2b2",
                        },
                        "&:hover::before": {
                            borderBottomWidth: "2px",
                        },
                    },
                    adornedEnd: {
                        paddingRight: "0px",
                    },
                },
            },
            MuiFormLabel: {
                styleOverrides: {
                    root: {
                        fontSize: 16,
                        color: "rgba(0,0,0,0.6)",
                    },
                },
            },
            MuiFormHelperText: {
                styleOverrides: {
                    root: {
                        marginTop: 0,
                        paddingTop: 0,
                    },
                },
            },
            MuiInputLabel: {
                styleOverrides: {
                    shrink: {
                        color: "rgba(0,0,0,0.3) !important",
                    },
                },
            },
            MuiNativeSelect: {
                styleOverrides: {
                    fontSize: 16,
                    icon: {
                        color: "rgba(0,0,0,1)",
                    },
                    iconFilled: {
                        right: 16,
                    },
                },
            },
            MuiInputAdornment: {
                styleOverrides: {
                    root: {
                        color: "rgba(0,0,0,1)",
                    },
                },
            },
            MuiSlider: {
                styleOverrides: {
                    root: {
                        height: 4,
                        margin: "8px 0",
                        padding: 0,
                    },
                    rail: {
                        height: 4,
                        borderRadius: 2,
                        backgroundColor: " #ccc",
                        opacity: 1,
                    },
                    track: {
                        height: 4,
                        borderRadius: 2,
                    },
                    mark: {
                        display: "none",
                    },
                    thumb: {
                        height: '12px !important',
                        width: '12px !important',
                    },
                    markLabel: {
                        top: 9,
                        fontSize: 12,
                        color: "#333",
                        "&[style*='0%;']": {
                            "left": "18px !important",
                        },
                        "&[style*='100%;']": {
                            "right": "-15px !important",
                            "left": "auto !important",
                        },
                    },
                },
            },
            MuiSvgIcon: {
                styleOverrides: {
                    root: {
                        width: 24,
                        height: 24,
                        marginBottom: 1,
                    },
                },
            },
            MuiPaper: {
                styleOverrides: {
                    outlined: {
                        border: "none",
                        boxShadow: "0 2px 3px rgba(0, 0, 0, 0.161)",
                    },
                },
            },
        },
    };
}